



































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import TextField from '@/reusable/Form/TextField.vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import SwitchForm from '@/reusable/Form/SwitchForm.vue';
import config from '@/config/index';
import { Validator } from 'vee-validate';
import HandleErrors from '@/config/handleErrors';
import moment from 'moment';
import {
  emitFormChangeEvent,
  formErrors,
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Snotify } from '@/snotify/Snotify';
import { EstadoEntidad } from '../../config/enums';
import ValidaRut from '@/config/validaRut';
import { LoadingService } from '@/services/loadingService';

import { fetchGiro } from '@/reusable/Giro/fetchGiro';
import { Giro } from '@/reusable/Giro/Giro';

@Component({
  components: {
    TextField,
    FormFieldsContainer,
  },
})
export default class ContactoEjecutivoForm extends Vue {
  @Prop() contactoEjecutivoSeleccionado: any;

  isFormValid: boolean = false;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  axios: AxiosVue = new AxiosVue(ServicioProxy.Integracion);

  mensajeEstado: string = '';
  modoVer: boolean = true;

  vr: ValidaRut = new ValidaRut();

  formFields: FormFieldDefMap = {
    nombreEjecutivoComercial: {
      label: 'Nombre Ejecutivo Comercial',
      id: 'nombreEjecutivoComercial',
      value: '',
    },
    telefonoEjecutivoComercial: {
      label: 'Teléfono',
      id: 'telefonoEjecutivoComercial',
      value: '',
    },
    correoEjecutivoComercial: {
      label: 'Correo Electrónico',
      id: 'correoEjecutivoComercial',
      value: '',
    },
    nombreEjecutivoCobranza: {
      label: 'Nombre Ejecutivo de Cobranza',
      id: 'nombreEjecutivoCobranza',
      value: '',
    },
    telefonoEjecutivoCobranza: {
      label: 'Teléfono',
      id: 'telefonoEjecutivoCobranza',
      value: '',
    },
    correoEjecutivoCobranza: {
      label: 'Correo Electrónico',
      id: 'correoEjecutivoCobranza',
      value: '',
    },

    nombreContactoTecnico: {
      label: 'Nombre Contacto Técnico',
      id: 'NombreContactoTecnico',
      value: '',
    },
    telefonoContactoTecnico: {
      label: 'Teléfono',
      id: 'telefonoContactoTecnico',
      value: '',
    },
    correoContactoTecnico: {
      label: 'Correo Electrónico',
      id: 'correoContactoTecnico',
      value: '',
    },
  };

  mounted() {
    this.$validator.localize('es', makeValidatorDictionary(this.formFields));
    const self = this;
    let r = this.vr;

    // this.handleFormChange(this.formFields);
    this.handlecalibracionSeleccionadaChange();
  }

  @Watch('contactoEjecutivoSeleccionado', { deep: true })
  handlecalibracionSeleccionadaChange() {
    if (!this.contactoEjecutivoSeleccionado) {
      return;
    }
    this.formFields.nombreEjecutivoComercial.value = this.contactoEjecutivoSeleccionado.nombreEjeComercial;
    this.formFields.telefonoEjecutivoComercial.value = this.contactoEjecutivoSeleccionado.telefonoEjeComercial;
    this.formFields.correoEjecutivoComercial.value = this.contactoEjecutivoSeleccionado.emailEjeComercial;

    this.formFields.nombreEjecutivoCobranza.value = this.contactoEjecutivoSeleccionado.nombreEjecCobranza;
    this.formFields.correoEjecutivoCobranza.value = this.contactoEjecutivoSeleccionado.emailEjecCobranza;
    this.formFields.telefonoEjecutivoCobranza.value = this.contactoEjecutivoSeleccionado.telefonoEjecCobranza;

    this.formFields.nombreContactoTecnico.value = this.contactoEjecutivoSeleccionado.nombreTecnico;
    this.formFields.correoContactoTecnico.value = this.contactoEjecutivoSeleccionado.emailTecnico;
    this.formFields.telefonoContactoTecnico.value = this.contactoEjecutivoSeleccionado.telefonoTecnico;
  }
}
